import { Head, Link, router } from "@inertiajs/react"
import { Check, PauseCircle, Search, ShieldCheck } from "lucide-react"
import { AdminLayout } from "../components/AdminLayout"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"

function formatDate(iso) {
  return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
}

// Serious Brand check flags a coach chose to keep in a Kingdom Factors book.
// The book cannot go to print until KF admin clears the flag; "Keep on hold"
// tells the coach to change the words.
export default function BrandFlagsIndex({ currentUser, flags = [] }) {
  return (
    <AdminLayout currentUser={currentUser}>
      <Head title="Book flags - Kingdom Factor" />
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-zinc-900">Book flags</h1>
          <p className="text-zinc-600">
            Serious Brand check flags that a coach kept in their Kingdom Factors book. Read the words, then clear the flag or keep the book on hold. The coach gets an email either way.
          </p>
        </div>

        {flags.length === 0 ? (
          <Card>
            <CardContent className="py-12 text-center text-sm text-zinc-600">
              <ShieldCheck className="mx-auto mb-2 h-6 w-6 text-zinc-400" />
              No flags are waiting for a decision.
            </CardContent>
          </Card>
        ) : (
          flags.map((flag) => (
            <Card key={flag.id}>
              <CardContent className="space-y-2 text-sm">
                <div className="flex flex-wrap items-center gap-2 text-xs text-zinc-600">
                  <span className="rounded-full bg-red-600 px-2 py-0.5 font-semibold text-white">Serious</span>
                  <span>{flag.topic}</span>
                  <span>·</span>
                  <span><b>{flag.book}</b> by {flag.coach}</span>
                  <span>·</span>
                  <span>{flag.part}</span>
                  <span className="ml-auto">Kept {formatDate(flag.keptAt)}</span>
                </div>
                <p className="text-base italic text-zinc-900">“{flag.quote}”</p>
                {flag.chapterId && (
                  <Link href={`/app/admin/books/${flag.bookId}/chapters/${flag.chapterId}#flag-${flag.id}`}
                    className="inline-flex items-center gap-1 text-xs font-semibold text-kf-red underline-offset-4 hover:underline">
                    <Search className="h-3.5 w-3.5" /> Read it in the chapter
                  </Link>
                )}
                <p className="text-zinc-700"><b>Why:</b> {flag.reason}</p>
                {flag.suggestion && <p className="text-zinc-700"><b>Suggested fix:</b> {flag.suggestion}</p>}
                {flag.held && <p className="text-xs text-red-700">On hold. The coach was told to change the words.</p>}
                <div className="flex gap-2 pt-1">
                  <Button size="sm" onClick={() => router.post(`/app/admin/brand_flags/${flag.id}/clear`)}>
                    <Check className="h-4 w-4" /> Clear the flag
                  </Button>
                  {!flag.held && (
                    <Button size="sm" variant="outline" onClick={() => router.post(`/app/admin/brand_flags/${flag.id}/hold`)}>
                      <PauseCircle className="h-4 w-4" /> Keep on hold
                    </Button>
                  )}
                </div>
              </CardContent>
            </Card>
          ))
        )}
      </div>
    </AdminLayout>
  )
}
